var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',[_c('canvas',{attrs:{"id":"chart"}})]),_vm._v(" ChartType(s) : "+_vm._s(this.chartType)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }